import api from './api'

export const historyService = {
  // Get all history entries
  async getHistoryEntries() {
    const response = await api.get('/history/')
    return response.data
  },

  // Get a specific history entry
  async getHistoryEntry(id) {
    const response = await api.get(`/history/${id}`)
    return response.data
  },

  // Create a new history entry (admin)
  async createHistoryEntry(data) {
    const response = await api.post('/history/', data)
    return response.data
  },

  // Update a history entry (admin)
  async updateHistoryEntry(id, data) {
    const response = await api.put(`/history/${id}`, data)
    return response.data
  },

  // Delete a history entry (admin)
  async deleteHistoryEntry(id) {
    const response = await api.delete(`/history/${id}`)
    return response.data
  }
}